<div class="floating-container" [class.active]="active" [class.dark-theme]="theme === 'dark'">
	<ng-content></ng-content>
	<div class="fc-outline">
		<div class="fc-outline-leading"></div>
		<div class="fc-outline-label">
			<label>{{label}}</label>
		</div>
		<div class="fc-outline-trailing"></div>
	</div>
</div>
